import React, { Component } from "react";
import { isMobile } from "react-device-detect";
import { translate } from "react-polyglot";
import { Col, Row } from "reactstrap";
import { Subscribe } from "unstated";
import parameterList from "../../helpers/parameterList";
import FilterState from "../../state/FilterState";
import CustomButton from "../helpers/CustomButton";
import DesktopFilter from "./DesktopFilter";
import MobileFilter from "./MobileFilter";

interface IProps {
  handleFilterUpdate: (filters: IFilter[]) => void;
  filters: IFilter[];
}

interface IFilter {
  id: string;
  parameter: string;
  operator: string;
  values: string[];
  isPrimary: boolean;
}

class ParameterFilter extends Component<IProps & TranslateProps> {
  public state = {
    filters: [] as IFilter[]
  };
  constructor(props: IProps & TranslateProps) {
    super(props);
  }

  public render() {
    const { t } = this.props;

    const paramList = parameterList.map(parameter => {
      return {
        label: t(`parameters.${parameter.name}`),
        type: parameter.type,
        value: parameter.name
      };
    });

    return (
      <Subscribe to={[FilterState]}>
        {(filterState: any) => {
          const {
            state: { filters }
          } = filterState;

          const {
            addFilter,
            removeFilter,
            clearFilters,
            handleFilterParameter,
            handleFilterOperator,
            handleFilterValue
          } = filterState;
          return (
            <React.Fragment>
              <Row className="pt-1 pb-1">
                <Col>
                  {filters
                    .filter((f: IFilter) => !f.isPrimary)
                    .map((filter: IFilter, index: number) => {
                      return isMobile ? (
                        <MobileFilter
                          filter={filter}
                          key={index}
                          handleOperatorChange={handleFilterOperator}
                          handleParameterChange={handleFilterParameter}
                          handleValueChange={handleFilterValue}
                          addFilter={addFilter}
                          removeFilter={removeFilter}
                          parameterList={paramList}
                          isLast={index === filters.length - 1 ? true : false}
                        />
                      ) : (
                        <DesktopFilter
                          filter={filter}
                          key={index}
                          handleOperatorChange={handleFilterOperator}
                          handleParameterChange={handleFilterParameter}
                          handleValueChange={handleFilterValue}
                          addFilter={addFilter}
                          removeFilter={removeFilter}
                          parameterList={paramList}
                          isLast={index === filters.length - 1 ? true : false}
                        />
                      );
                    })}
                </Col>
              </Row>
              {filters.length > 0 ? (
                <Row className="pt-1 pb-1 pl-1">
                  <Col>
                    <CustomButton
                      className="shadow-none"
                      color="success"
                      isCircle={true}
                      onClick={() => addFilter("", parameterList[0].name, [""])}
                    >
                      <i className="fas fa-plus" />
                    </CustomButton>
                    <CustomButton
                      color="secondary"
                      className="shadow-none"
                      onClick={clearFilters}
                    >
                      {t("labels.clearFilters")}
                    </CustomButton>
                  </Col>
                </Row>
              ) : null}
            </React.Fragment>
          );
        }}
      </Subscribe>
    );
  }
}

export default translate()(ParameterFilter);
